import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver/FileSaver';
import { UserService } from '../../../../services/user.service';
import { ReportService } from '../../../../services/report.service';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-federal-government',
  templateUrl: './federal-government.component.html',
  styleUrls: ['./federal-government.component.css']
})
export class PukalAccountReportsFederalGovernmentComponent implements OnInit, OnDestroy {
  warrant_auth_code: string = 'JA';
  allSub: Subscription[] = [];
  pukalaccrptform: FormGroup;
  errorMessage: string = '';
  downloadMessage: string = '';
  loading: boolean = false;
  userName: string = '';
  screenCode: string = '';
  isSubmit: boolean = false;
  accOffCodes = [];
  exportFileTypes = [];

  constructor(private userService: UserService,
    private reportService: ReportService,
    public snackBar: MatSnackBar) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.pukalaccrptform = new FormGroup({
      accoffcode: new FormControl({ value: '', disabled: false }, [Validators.required]),
      exportfiletype: new FormControl({ value: '', disabled: false }, [Validators.required])
    });

    this.loading = true;
    let init_sub = this.reportService.getInitPukalAccReports()
      .subscribe(
        (value) => {
          this.loading = false;
          this.accOffCodes = value.body['accountOffices'];
          this.exportFileTypes = value.body['exportFileTypeDT'];

          this.pukalaccrptform.setValue({
            accoffcode: value.body['accountOffices'][0],
            exportfiletype: value.body['exportFileTypeDT'][0].VALUE
          });
        },
        (error) => {
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(init_sub);
  }

  onSubmit(form: FormGroup) {
    // if (this.pukalaccrptform.get('accoffcode')!.value === 0) {
    //     this.openSnackBar('No Account Office Code is selected. Please make sure at least one is selected.', '');
    //     return;
    // }
    this.isSubmit = true;
    this.downloadMessage = 'System is generating report....';

    let pukalAccount = {
      Account_Office_Code: this.pukalaccrptform.get('accoffcode')!.value,
      Export_File_Type: this.pukalaccrptform.get('exportfiletype')!.value
    }

    let save_sub = this.reportService.downloadFedPukalAccReports(pukalAccount)
      .subscribe(
        (value) => {
          if (value.status === 204) {
            this.isSubmit = false;
            this.openSnackBar('Download failed.', '');
          } else if (value.status === 200) {
            if (pukalAccount.Export_File_Type === '.xls') {
              let blob = new Blob([value.body], { type: 'application/vnd.ms-excel' });
              saveAs(blob, 'JAN Pukal Account.xls');
            } else if (pukalAccount.Export_File_Type === '.pdf') {
              let blob = new Blob([value.body], { type: 'application/pdf' });
              saveAs(blob, 'JAN Pukal Account.pdf');
            }

            this.openSnackBar('Report Created.', '');
            this.isSubmit = false;
          } else {
            this.isSubmit = false;
            this.openSnackBar('Download failed.', '');
          }
        },
        (error) => {
          this.errorMessage = <any>error;
          this.isSubmit = false;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(save_sub);
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
